/*! ============================================================================
 *  DRBB - Direct-Response Buy Box  .  v2.2.0  .  Guap Media
 *  Brand-agnostic subscription/one-time buy box for Shopify stores.
 *  Renders itself from window.DRBB_CONFIG. Contains ZERO product data and
 *  prints ZERO hard-coded prices.
 *
 *  v2.2.0 - LIVE PRICING. Every number the widget prints is read from the
 *  Shopify Storefront API at load, in the SAME country context the cart is
 *  created in, so what is printed is what checkout charges - by construction:
 *    - one-time price      = ProductVariant.price
 *    - subscription price  = the variant's sellingPlanAllocation for the
 *                            configured selling plan (Shopify's own rounding)
 *    - save $ / save %, per-day math, gift-stack totals - all derived at runtime
 *  Config carries variant IDs + selling-plan IDs + copy. Copy may use tokens:
 *    {sub} {ot} {save} {savePct} {perDay} {perDayOt} {perUnit} {perUnitOt}
 *    {cycle} {nights} {cmp} {giftTotal} {physicalTotal} {digitalTotal} {name}
 *
 *  Works on: a Shopify PDP, a Shopify page/section, or ANY off-domain
 *  landing page or advertorial - checkout runs through the Storefront API
 *  cartCreate mutation, which is cross-origin safe.
 *
 *  Install:  1. a mount element with id "drbb"
 *            2. a config script that sets window.DRBB_CONFIG = { ... }
 *            3. this engine, inline or via script src. Config must load first.
 *            NOTE: never put a closing script tag inside a comment here.
 *            NOTE: every variant the config names (tiers AND gift items) must
 *            be published to the sales channel that owns the storefront token,
 *            or the Storefront API returns null for it.
 *
 *  Safety interlocks that ship ON by default and must not be removed:
 *    1. PLAN-ID GUARD  - a tier's selling plan must be found on the variant's
 *       live sellingPlanAllocations. Missing/placeholder/unattached plan =>
 *       that subscription path is disabled.
 *    2. PRICE GUARD    - printed prices come from the Storefront API in the
 *       cart's own country context; at checkout the cart line is compared to
 *       the printed price and, if the store changed price in between, the
 *       widget re-reads prices and asks the buyer to confirm instead of
 *       advertising a price checkout will not honour. Prices that fail to
 *       load are never replaced by a fallback number - the widget shows
 *       "Retry" instead.
 *    3. GIFT FENCE     - the discount code is only ever sent on tiers listed in
 *       gift.attachTo, and only in subscription mode.
 *    4. AVAILABILITY   - a tier whose variant (or promised gift line) is not
 *       available for sale is disabled instead of failing at checkout.
 *  ========================================================================== */
(function () {
  "use strict";

  var C = window.DRBB_CONFIG;
  if (!C || !C.tiers || !C.tiers.length) return;

  var D = {
    mount: "#drbb",
    currency: "USD",
    currencySymbol: "$",
    label: "Choose your plan",
    ctaText: "Add to cart",
    retryText: "Retry",
    otPrefix: "One-time purchase — ",
    subPrefixFmt: "Subscribe & save {pct}% — ",
    badgeText: "Best value",
    accordionLabel: "What arrives, and when",
    reviews: null,
    gift: null,
    api: { country: "US" },
    theme: {},
    attrKeys: ["utm_source","utm_medium","utm_campaign","utm_content","utm_term",
               "fbclid","gclid","ttclid","v","fnl","ver"],
    attrStore: "drbb_attr"
  };
  Object.keys(D).forEach(function (k) { if (C[k] === undefined) C[k] = D[k]; });
  if (!C.api.country) C.api.country = "US";

  var T = {
    accent: "#ad536b", accentDeep: "#8a3f54", accentSoft: "#d99fae",
    ink: "#3a2f31", ink2: "#6b5c5e", bg: "#fdfbf7", card: "#fffdfb",
    tint: "#f6efe9", label: "#fdfbf7",
    hair: "rgba(173,83,107,.20)", hairSoft: "rgba(173,83,107,.13)",
    ctaHover: "#763547",
    font: 'Poppins,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
    maxWidth: "675px"
  };
  Object.keys(C.theme || {}).forEach(function (k) { T[k] = C.theme[k]; });

  var ORDER = C.tiers.map(function (t, i) { return t.key || ("t" + i); });
  var TIER = {};
  C.tiers.forEach(function (t, i) { TIER[t.key || ("t" + i)] = t; });

  /* Hard-coded price keys are ignored on purpose. Prices are live. */
  var STALE = ["sub", "ot", "planPct", "saveSubPct", "saveOtPct"];
  C.tiers.forEach(function (t) {
    STALE.forEach(function (k) {
      if (t[k] != null && window.console && console.warn) {
        console.warn("DRBB: tier '" + (t.key || t.name) + "' carries '" + k + "' in config - ignored, prices are read live from Shopify.");
      }
      delete t[k];
    });
  });

  var state = { tier: ORDER[0], mode: (C.tiers[0].defaultMode || "sub") };

  /* ---- live price store --------------------------------------------------- */
  var P = { ready: false, loading: false, error: null, byVariant: {}, fetchedAt: 0 };

  var esc = function (s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  };
  var cents = function (n) { return Math.round(Number(n) * 100); };
  var money = function (n) {
    if (n == null || isNaN(n)) return "—";
    return C.currencySymbol + (cents(n) / 100).toFixed(2);
  };
  var moneySmart = function (n) {
    if (n == null || isNaN(n)) return "—";
    var c = cents(n);
    return C.currencySymbol + (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2));
  };
  var t_ = function () { return TIER[state.tier]; };
  var vid = function (v) { return String(v).replace(/^gid:\/\/shopify\/ProductVariant\//, ""); };
  var pid = function (p) { return String(p).replace(/^gid:\/\/shopify\/SellingPlan\//, ""); };

  var planConfigured = function (k) {
    var p = TIER[k].sellingPlan;
    return !!p && String(p).indexOf("__") !== 0 && String(p).indexOf("PENDING") !== 0;
  };

  /* Live numbers for a tier. null until prices are loaded. */
  var live = function (k) {
    var x = TIER[k], v = P.byVariant[vid(x.variant)];
    if (!P.ready || !v) return null;
    var out = {
      ot: v.price, cmp: v.cmp, avail: v.avail, currency: v.currency,
      sub: null, planFound: false, save: null, savePct: 0, saveOtPct: 0
    };
    if (planConfigured(k) && v.plans[pid(x.sellingPlan)] != null) {
      out.planFound = true;
      out.sub = v.plans[pid(x.sellingPlan)];
      out.save = (cents(out.ot) - cents(out.sub)) / 100;
      out.savePct = out.ot > 0 ? Math.round((out.ot - out.sub) / out.ot * 100) : 0;
    }
    if (out.cmp != null && out.cmp > out.ot) out.saveOtPct = Math.round((out.cmp - out.ot) / out.cmp * 100);
    return out;
  };
  var hasSub = function (k) { return TIER[k].sellingPlan !== null && TIER[k].sellingPlan !== undefined; };

  var giftTiers = (C.gift && C.gift.attachTo) || [];
  /* Back-compat: the v2.0 flat gift schema (gift.code + gift.lines, applied to
     every tier in gift.attachTo) is normalised into the v2.1 byTier schema. */
  if (C.gift && !C.gift.byTier && (C.gift.lines || C.gift.code)) {
    C.gift.byTier = {};
    giftTiers.forEach(function (k) {
      C.gift.byTier[k] = { code: C.gift.code || null, lines: (C.gift.lines || []).slice() };
    });
  }
  var giftFor = function () {
    return state.mode === "sub" && C.gift && C.gift.byTier && C.gift.byTier[state.tier];
  };
  var giftOn = function () { return !!giftFor(); };

  var itemPrice = function (g) {
    if (g.variant != null) {
      var v = P.byVariant[vid(g.variant)];
      return v ? v.price : null;
    }
    if (g.was != null) { var n = Number(String(g.was).replace(/[^0-9.]/g, "")); return isNaN(n) ? null : n; }
    return null;
  };
  var giftTotals = function () {
    var items = (C.gift && C.gift.items) || [], phys = 0, digi = 0, missing = false;
    items.forEach(function (g) {
      var p = itemPrice(g);
      if (p == null) { missing = true; return; }
      if (g.physical) phys += cents(p); else digi += cents(p);
    });
    return { physical: phys / 100, digital: digi / 100, total: (phys + digi) / 100, missing: missing };
  };

  /* Token substitution for config copy. */
  var tokens = function (k) {
    var x = TIER[k], L = live(k), G = giftTotals(), ready = !!L;
    var m = function (n) { return ready ? money(n) : "…"; };
    var ms = function (n) { return ready ? moneySmart(n) : "…"; };
    var per = function (amount, div) {
      return (ready && amount != null && div) ? money(amount / div) : "…";
    };
    return {
      name: x.name, cycle: x.cycle || "", nights: x.nights || "",
      sub: L && L.sub != null ? m(L.sub) : "…",
      ot: L ? m(L.ot) : "…",
      cmp: L && L.cmp != null ? m(L.cmp) : "",
      save: L && L.save != null ? m(L.save) : "…",
      savePct: L ? String(L.savePct) : "…",
      perDay: L ? per(L.sub, x.nights) : "…",
      perDayOt: L ? per(L.ot, x.nights) : "…",
      perUnit: L ? per(L.sub, x.units) : "…",
      perUnitOt: L ? per(L.ot, x.units) : "…",
      giftTotal: ready ? ms(G.total) : "…",
      physicalTotal: ready ? ms(G.physical) : "…",
      digitalTotal: ready ? ms(G.digital) : "…"
    };
  };
  var fmt = function (s, tok) {
    return String(s == null ? "" : s).replace(/\{(\w+)\}/g, function (all, key) {
      return tok[key] != null ? tok[key] : all;
    });
  };

  var perUnit = function (tier, amount) {
    if (tier.unitText) return fmt(tier.unitText, tokens(tier.key));
    if (!tier.nights) return "";
    if (amount == null) return "";
    return money(amount / tier.nights) + " / day across " + tier.nights + " " + (tier.unitNoun || "nights");
  };

  function css() {
    return "\
.drbb,.drbb *{box-sizing:border-box;margin:0;padding:0}\
.drbb{--a:" + T.accent + ";--ad:" + T.accentDeep + ";--as:" + T.accentSoft + ";--ink:" + T.ink + ";--ink2:" + T.ink2 + ";\
--bg:" + T.bg + ";--card:" + T.card + ";--tint:" + T.tint + ";--lbl:" + T.label + ";--hair:" + T.hair + ";--hairs:" + T.hairSoft + ";\
font-family:" + T.font + ";color:var(--ink);background:var(--bg);max-width:" + T.maxWidth + ";width:100%;margin:0 auto;\
-webkit-font-smoothing:antialiased;container-type:inline-size}\
.drbb__label{font-size:11px;font-weight:700;letter-spacing:1.76px;text-transform:uppercase;color:var(--ad);margin:0 0 12px;padding:0 2px 8px 0}\
.drbb__reviews{font-size:13px;color:var(--ink2);margin:0 0 12px;letter-spacing:.2px}\
.drbb__reviews b{color:var(--ad)}\
.drbb__group{border:0;display:flex;flex-direction:column;gap:10px}\
.drbb__card{position:relative;background:transparent;border:1.25px solid var(--hairs);border-radius:14px;\
padding:15.5px 17.5px 13.5px;cursor:pointer;transition:border-color .18s,background-color .18s;outline:none}\
.drbb__card:hover{border-color:var(--hair)}\
.drbb__card:focus-visible{box-shadow:0 0 0 3px rgba(0,0,0,.12)}\
.drbb__card.is-on{background:var(--card);border-color:var(--a)}\
.drbb__badge{position:absolute;top:-1.25px;right:-1.25px;background:var(--ad);color:var(--lbl);font-size:10px;\
font-weight:700;letter-spacing:1.2px;text-transform:uppercase;padding:6px 14px;border-radius:0 13px 0 12px;line-height:1}\
.drbb__head{display:flex;align-items:center;gap:9px;flex-wrap:wrap;padding-right:96px}\
.drbb__dot{width:17px;height:17px;border-radius:999px;border:2.5px solid var(--hair);flex:0 0 17px;position:relative;transition:border-color .18s}\
.drbb__card.is-on .drbb__dot{border-color:var(--a)}\
.drbb__card.is-on .drbb__dot::after{content:\"\";position:absolute;inset:2.5px;border-radius:999px;background:var(--a)}\
.drbb__title{font-size:17px;font-weight:700;color:var(--ink);letter-spacing:-.2px}\
.drbb__pill{font-size:10.5px;font-weight:700;letter-spacing:.84px;text-transform:uppercase;color:var(--ad);\
background:rgba(0,0,0,.06);border-radius:999px;padding:5px 11px;line-height:1;white-space:nowrap}\
.drbb__supply{font-size:12.5px;color:var(--ink2);margin:5px 0 0 26px}\
.drbb__pricerow{display:flex;align-items:baseline;gap:8px;margin:9px 0 0 26px;flex-wrap:wrap}\
.drbb__price{font-size:30px;font-weight:400;letter-spacing:-.3px;color:var(--ink);line-height:1.1;min-width:2.2em}\
.drbb__price.is-loading{display:inline-block;height:.9em;width:3.6em;border-radius:6px;background:var(--tint);color:transparent;\
animation:drbb-pulse 1.1s ease-in-out infinite;vertical-align:baseline}\
@keyframes drbb-pulse{0%,100%{opacity:.55}50%{opacity:1}}\
.drbb__cycle{font-size:14px;font-weight:500;letter-spacing:-.3px;color:var(--ink2)}\
.drbb__meta{display:flex;justify-content:space-between;align-items:baseline;gap:14px;margin:6px 0 0 26px;flex-wrap:wrap}\
.drbb__billed{font-size:12px;color:var(--ink2)}\
.drbb__unit{font-size:12.5px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:var(--ad);white-space:nowrap}\
.drbb__ticks{list-style:none;margin:14px 0 0;display:flex;flex-direction:column;gap:7px}\
.drbb__ticks li{font-size:14px;font-weight:500;letter-spacing:-.4px;color:var(--ad);display:flex;gap:9px;align-items:flex-start;line-height:1.35}\
.drbb__ticks svg{flex:0 0 13px;margin-top:3px}\
.drbb__card:not(.is-on) .drbb__ticks,.drbb__card:not(.is-on) .drbb__kit,\
.drbb__card:not(.is-on) .drbb__acc,.drbb__card:not(.is-on) .drbb__accpanel{display:none}\
.drbb__kit{margin-top:15px;transition:opacity .18s}\
.drbb__kitlabel{font-size:10px;font-weight:700;letter-spacing:1.3px;text-transform:uppercase;color:var(--ad);margin-bottom:9px;line-height:1.4}\
.drbb__kitsub{font-size:10px;font-weight:700;letter-spacing:1.3px;text-transform:uppercase;color:var(--ad);opacity:.72;margin:0 0 9px;line-height:1.4}\
.drbb__kitgrid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}\
.drbb__kitgrid--phys{grid-template-columns:repeat(2,minmax(0,1fr));margin-bottom:13px}\
.drbb__kitgrid--phys .drbb__tile{height:132px;padding:7px}\
.drbb__kitgrid--phys .drbb__was{font-size:12.5px}\
.drbb__kitgrid--phys .drbb__iname{font-size:11.5px;font-weight:600;color:var(--ink)}\
.drbb__item{text-align:center}\
.drbb__tile{height:96px;background:var(--tint);border-radius:10px;display:flex;align-items:center;justify-content:center;\
margin-bottom:6px;overflow:hidden;padding:5px}\
.drbb__tile img{width:100%;height:100%;object-fit:contain;display:block;border-radius:6px}\
.drbb__was{display:block;font-size:11px;font-weight:700;color:var(--a);text-decoration:line-through;line-height:1.2}\
.drbb__iname{display:block;font-size:10.5px;font-weight:500;color:var(--ink2);line-height:1.25;margin-top:2px}\
.drbb__kit.is-off{opacity:.42}\
.drbb__kitnote{display:none;font-size:11.5px;font-weight:600;color:var(--ad);margin-top:9px}\
.drbb__kit.is-off .drbb__kitnote{display:block}\
.drbb__kittotal{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin-top:12px;padding-top:10px;border-top:1px solid var(--hairs)}\
.drbb__kittotal i{font-style:normal;font-size:11.5px;font-weight:600;color:var(--ink2)}\
.drbb__kittotal b{font-size:14.5px;font-weight:700;color:var(--ad);white-space:nowrap}\
.drbb__acc{width:100%;margin-top:13px;background:var(--tint);border:1.25px solid var(--hairs);border-radius:999px;\
padding:9px 14px;font-family:inherit;font-size:10.5px;font-weight:700;letter-spacing:1.1px;text-transform:uppercase;\
color:var(--ad);cursor:pointer;display:flex;align-items:center;justify-content:center;gap:7px;min-height:44px}\
.drbb__acc svg{transition:transform .2s}\
.drbb__acc[aria-expanded=\"true\"] svg{transform:rotate(180deg)}\
.drbb__accpanel{margin-top:10px;padding:13px 15px;background:var(--tint);border-radius:12px}\
.drbb__accpanel p{font-size:13px;line-height:1.55;color:var(--ink2)}\
.drbb__accpanel p+p{margin-top:8px}\
.drbb__accpanel b{color:var(--ad);font-weight:600}\
.drbb__ot{text-align:center;margin:14px 0 0}\
.drbb__otbtn{background:none;border:0;font-family:inherit;font-size:13.5px;font-weight:500;color:var(--ink2);\
text-decoration:underline;text-underline-offset:3px;cursor:pointer;padding:6px 8px}\
.drbb__otbtn:hover{color:var(--ad)}\
.drbb__otbtn.is-on{color:var(--ad);font-weight:700;text-decoration-thickness:2px}\
.drbb__cta{width:100%;height:54px;margin-top:14px;background:var(--ad);color:var(--lbl);border:0;border-radius:24px;\
font-family:inherit;font-size:15px;font-weight:700;letter-spacing:.9px;text-transform:uppercase;cursor:pointer;transition:background-color .18s}\
.drbb__cta:hover{background:" + T.ctaHover + "}\
.drbb__trust{list-style:none;display:flex;justify-content:center;flex-wrap:wrap;gap:8px 22px;margin:14px 0 0}\
.drbb__trust li{font-size:12px;font-weight:500;color:var(--ink2);display:flex;align-items:center;gap:6px}\
.drbb__disc{font-size:11px;line-height:1.55;color:var(--ink2);margin-top:13px;text-align:center}\
@container (max-width:520px){\
.drbb__card{padding:14px 13px 12px;border-radius:12px}\
.drbb__head{padding-right:0}\
.drbb__badge{position:static;display:inline-block;margin:0 0 9px;border-radius:6px}\
.drbb__title{font-size:16px}.drbb__price{font-size:27px}\
.drbb__supply,.drbb__pricerow,.drbb__meta{margin-left:0}\
.drbb__meta{flex-direction:column;gap:3px}\
.drbb__kitgrid{grid-template-columns:repeat(2,minmax(0,1fr));gap:9px}\
.drbb__kittotal{flex-direction:column;align-items:flex-start;gap:2px}\
.drbb__trust{flex-direction:column;align-items:center;gap:7px}}";
  }

  var TICK = '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">' +
             '<path d="M1.5 6.8 4.6 10 11.5 2.8" stroke="currentColor" stroke-width="2" ' +
             'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg width="10" height="7" viewBox="0 0 10 7" fill="none" aria-hidden="true">' +
             '<path d="M1 1.5 5 5.5 9 1.5" stroke="currentColor" stroke-width="1.8" ' +
             'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function tiles(items, phys) {
    return '<div class="drbb__kitgrid' + (phys ? " drbb__kitgrid--phys" : "") + '">' +
      items.map(function (g) {
        var p = itemPrice(g);
        return '<div class="drbb__item"><div class="drbb__tile">' +
          (g.img ? '<img src="' + esc(g.img) + '" alt="' + esc(g.name) + '" loading="lazy" decoding="async">' : "") +
          '</div>' + (p != null ? '<span class="drbb__was">' + esc(moneySmart(p)) + "</span>" : "") +
          '<span class="drbb__iname">' + esc(g.name) + "</span></div>";
      }).join("") + "</div>";
  }

  function kitHTML(key) {
    if (!C.gift) return "";
    var tok = tokens(key);
    var wantsPhys = giftTiers.indexOf(key) > -1;
    var phys = (C.gift.items || []).filter(function (g) { return g.physical; });
    var digi = (C.gift.items || []).filter(function (g) { return !g.physical; });
    var showPhys = wantsPhys && phys.length;
    var showDigi = digi.length && (TIER[key].bonuses !== false);
    if (!showPhys && !showDigi) return "";
    var total = showPhys ? C.gift.totalLabel : C.gift.digitalLabel;
    var sum = showPhys ? C.gift.totalSummary : C.gift.digitalSummary;
    return '<div class="drbb__kit" data-kit>' +
      '<p class="drbb__kitlabel">' + esc(fmt(showPhys ? (C.gift.headline || "Free in your first box")
                                                      : (C.gift.digitalHeadline || "Free with your plan"), tok)) + "</p>" +
      (showPhys ? tiles(phys, true) : "") +
      (showPhys && showDigi && C.gift.digitalSubhead
        ? '<p class="drbb__kitsub">' + esc(fmt(C.gift.digitalSubhead, tok)) + "</p>" : "") +
      (showDigi ? tiles(digi, false) : "") +
      (total ? '<div class="drbb__kittotal"><i>' + esc(fmt(sum || "", tok)) + "</i><b>" + esc(fmt(total, tok)) + "</b></div>" : "") +
      (C.gift.exclusiveNote ? '<p class="drbb__kitnote">' + esc(fmt(C.gift.exclusiveNote, tok)) + "</p>" : "") +
      "</div>";
  }

  function cardHTML(key, idx) {
    var t = TIER[key], on = idx === 0, id = "drbb-acc-" + idx, tok = tokens(key);
    return '<div class="drbb__card' + (on ? " is-on" : "") + '" role="radio" aria-checked="' + (on ? "true" : "false") +
      '" tabindex="0" data-tier="' + esc(key) + '">' +
      (t.badge ? '<span class="drbb__badge">' + esc(C.badgeText) + "</span>" : "") +
      '<div class="drbb__head"><span class="drbb__dot" aria-hidden="true"></span>' +
      '<span class="drbb__title">' + esc(t.name) + "</span>" +
      '<span class="drbb__pill" data-pill></span></div>' +
      (t.supply ? '<p class="drbb__supply">' + esc(fmt(t.supply, tok)) + "</p>" : "") +
      '<div class="drbb__pricerow"><span class="drbb__price" data-price></span>' +
      '<span class="drbb__cycle" data-cycle></span></div>' +
      '<div class="drbb__meta"><span class="drbb__billed" data-billed></span>' +
      '<span class="drbb__unit" data-unit></span></div>' +
      '<ul class="drbb__ticks" data-ticks></ul>' +
      '<div data-kitslot>' + kitHTML(key) + "</div>" +
      (t.arrives && t.arrives.length
        ? '<button type="button" class="drbb__acc" aria-expanded="false" aria-controls="' + id + '" data-acc>' +
          esc(C.accordionLabel) + CHEV + "</button>" +
          '<div class="drbb__accpanel" id="' + id + '" hidden data-arrives></div>'
        : "") +
      "</div>";
  }

  function shellHTML() {
    var r = C.reviews;
    return '<p class="drbb__label">' + esc(C.label) + "</p>" +
      (r ? '<p class="drbb__reviews">&#9733;&#9733;&#9733;&#9733;&#9733; <b>' + esc(r.rating) +
           "</b> &middot; " + esc(r.count) + " reviews</p>" : "") +
      '<div class="drbb__group" role="radiogroup" aria-label="' + esc(C.label) + '">' +
      ORDER.map(cardHTML).join("") + "</div>" +
      '<div class="drbb__ot"><button type="button" class="drbb__otbtn" data-ot>' +
      '<span data-otlabel></span><span data-otprice></span></button></div>' +
      '<button type="button" class="drbb__cta" data-cta>' + esc(C.ctaText) + "</button>" +
      '<ul class="drbb__trust">' +
      ["g", "s", "c"].map(function (k) {
        return "<li>" + TICK + '<span data-trust-' + k + "></span></li>";
      }).join("") + "</ul>" +
      '<p class="drbb__disc" data-disc></p>';
  }

  var host = document.querySelector(C.mount);
  if (!host) return;
  if (!document.getElementById("drbb-css")) {
    var st = document.createElement("style");
    st.id = "drbb-css"; st.textContent = css();
    document.head.appendChild(st);
  }
  var root = document.createElement("section");
  root.className = "drbb";
  root.id = "drbb-root";
  root.setAttribute("aria-label", C.label);
  root.innerHTML = shellHTML();
  host.appendChild(root);

  var cards   = [].slice.call(root.querySelectorAll(".drbb__card"));
  var otBtn   = root.querySelector("[data-ot]");
  var otLabel = root.querySelector("[data-otlabel]");
  var otPrice = root.querySelector("[data-otprice]");
  var cta     = root.querySelector("[data-cta]");
  var disc    = root.querySelector("[data-disc]");
  var trustG  = root.querySelector("[data-trust-g]");
  var trustS  = root.querySelector("[data-trust-s]");
  var trustC  = root.querySelector("[data-trust-c]");

  function attribution() {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(C.attrStore) || "{}") || {}; } catch (e) { stored = {}; }
    var q = new URLSearchParams(window.location.search), touched = false;
    C.attrKeys.forEach(function (k) { var v = q.get(k); if (v) { stored[k] = v; touched = true; } });
    if (touched) { try { sessionStorage.setItem(C.attrStore, JSON.stringify(stored)); } catch (e) {} }
    return stored;
  }
  function attrPairs() {
    var a = attribution(), out = [];
    Object.keys(a).forEach(function (k) { if (a[k]) out.push({ key: k, value: String(a[k]) }); });
    return out;
  }

  function fire(name, custom) {
    if (!C.pixelId || typeof window.fbq !== "function") return;
    var t = t_(), L = live(state.tier);
    var payload = {
      content_ids: [t.variant], content_type: "product", content_name: t.name,
      value: L ? (state.mode === "sub" ? L.sub : L.ot) : undefined, currency: C.currency,
      tier: state.tier, purchase_mode: state.mode,
      gift_stack: giftOn() ? ((C.gift && C.gift.version) || "v1") : "none"
    };
    try { custom ? window.fbq("trackCustom", name, payload) : window.fbq("track", name, payload); } catch (e) {}
  }

  /* ---- Storefront API: live prices -------------------------------------- */
  var PRICE_QUERY =
    "query DRBB($ids:[ID!]!,$country:CountryCode!) @inContext(country:$country){" +
    " nodes(ids:$ids){ ... on ProductVariant { id availableForSale" +
    " price { amount currencyCode } compareAtPrice { amount currencyCode }" +
    " sellingPlanAllocations(first:20) { nodes { sellingPlan { id name }" +
    " priceAdjustments { price { amount currencyCode } } } } } } }";

  function allVariantIds() {
    var ids = {};
    C.tiers.forEach(function (t) { if (t.variant != null) ids[vid(t.variant)] = 1; });
    if (C.gift) {
      (C.gift.items || []).forEach(function (g) { if (g.variant != null) ids[vid(g.variant)] = 1; });
      Object.keys(C.gift.byTier || {}).forEach(function (k) {
        ((C.gift.byTier[k] || {}).lines || []).forEach(function (l) { if (l.variant != null) ids[vid(l.variant)] = 1; });
      });
    }
    return Object.keys(ids);
  }

  function fetchPrices() {
    if (!C.api || !C.api.endpoint || !C.api.token) {
      P.error = "no-api"; P.ready = false; return Promise.reject(new Error("DRBB: api.endpoint/token missing"));
    }
    P.loading = true;
    var ids = allVariantIds();
    return fetch(C.api.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": C.api.token },
      body: JSON.stringify({ query: PRICE_QUERY, variables: {
        ids: ids.map(function (i) { return "gid://shopify/ProductVariant/" + i; }),
        country: C.api.country
      } })
    }).then(function (x) { return x.json(); }).then(function (r) {
      var nodes = r && r.data && r.data.nodes;
      if (!nodes) throw new Error("DRBB: price query returned no data" + (r && r.errors ? " - " + JSON.stringify(r.errors).slice(0, 200) : ""));
      var map = {};
      nodes.forEach(function (n) {
        if (!n || !n.price) return;
        var plans = {};
        ((n.sellingPlanAllocations && n.sellingPlanAllocations.nodes) || []).forEach(function (a) {
          var adj = a.priceAdjustments && a.priceAdjustments[0];
          if (a.sellingPlan && adj && adj.price) plans[pid(a.sellingPlan.id)] = Number(adj.price.amount);
        });
        map[vid(n.id)] = {
          price: Number(n.price.amount), currency: n.price.currencyCode,
          cmp: n.compareAtPrice ? Number(n.compareAtPrice.amount) : null,
          avail: !!n.availableForSale, plans: plans
        };
      });
      ids.forEach(function (i) {
        if (!map[i] && window.console && console.warn) {
          console.warn("DRBB: variant " + i + " not returned by the Storefront API - is the product published to this sales channel?");
        }
      });
      P.byVariant = map; P.ready = true; P.error = null; P.loading = false; P.fetchedAt = Date.now();
      return map;
    }).catch(function (err) {
      P.loading = false; P.ready = false; P.error = String(err && err.message || err);
      throw err;
    });
  }

  /* Why a tier's subscription path (or the tier itself) is blocked, or null. */
  function blockReason(k, mode) {
    if (!P.ready) return P.error ? "error" : "loading";
    var L = live(k);
    if (!L) return "This option isn't available in Shopify right now — the product variant could not be read from the store.";
    if (L.currency !== C.currency) return "Store pricing came back in " + L.currency + " but this page is set to " + C.currency + ". Fix the widget's currency/country settings before this path takes traffic.";
    if (!L.avail) return "This option is currently unavailable.";
    if (mode === "sub") {
      if (!planConfigured(k)) return "Subscription checkout is not wired yet — the selling-plan ID for this option is still a placeholder. Switch to the one-time purchase to test the cart path.";
      if (!L.planFound) return "This subscription plan isn't attached to this product in Shopify (plan " + pid(TIER[k].sellingPlan) + " is not on the variant), so the subscription path is disabled.";
      var g = C.gift && C.gift.byTier && C.gift.byTier[k];
      if (g) {
        var bad = (g.lines || []).filter(function (l) { var v = P.byVariant[vid(l.variant)]; return !v || !v.avail; });
        if (bad.length) return "A promised free gift is unavailable in Shopify right now (variant " + vid(bad[0].variant) + "), so this path is paused rather than checking out without it.";
      }
    }
    return null;
  }

  function render() {
    cards.forEach(function (card) {
      var key = card.getAttribute("data-tier"), t = TIER[key], L = live(key), tok = tokens(key);
      var on = key === state.tier, otMode = on && state.mode === "onetime";
      card.classList.toggle("is-on", on);
      card.setAttribute("aria-checked", on ? "true" : "false");

      var amount = L ? (otMode ? L.ot : L.sub) : null;
      var priceEl = card.querySelector("[data-price]");
      priceEl.textContent = amount != null ? money(amount) : ((P.ready || P.error) ? "—" : "…");
      priceEl.classList.toggle("is-loading", !P.ready && !P.error);
      card.querySelector("[data-cycle]").textContent = otMode ? "one-time" : (t.cycle || "");
      card.querySelector("[data-billed]").textContent = otMode
        ? "One-time purchase · no subscription"
        : "Ships " + (t.cycle || "") + " · renews until you cancel";
      card.querySelector("[data-unit]").textContent = amount != null ? perUnit(t, amount) : "";

      var pill = card.querySelector("[data-pill]");
      var pct = L ? (otMode ? L.saveOtPct : L.savePct) : 0;
      if (pct > 0) { pill.hidden = false; pill.textContent = "Save " + pct + "%"; }
      else { pill.hidden = true; }

      var ul = card.querySelector("[data-ticks]");
      if (ul) {
        var lines = (((t.ticks || {})[otMode ? "onetime" : "sub"]) || []).slice();
        ul.innerHTML = lines.map(function (l) { return "<li>" + TICK + esc(fmt(l, tok)) + "</li>"; }).join("");
      }
      var slot = card.querySelector("[data-kitslot]");
      if (slot) {
        slot.innerHTML = kitHTML(key);
        var kit = slot.querySelector("[data-kit]");
        if (kit) kit.hidden = otMode;
      }
      var ap = card.querySelector("[data-arrives]");
      if (ap) {
        ap.innerHTML = (t.arrives || []).map(function (p) {
          return "<p>" + (p.h ? "<b>" + esc(fmt(p.h, tok)) + "</b> " : "") + esc(fmt(p.b, tok)) + "</p>";
        }).join("");
      }

      if (!on) {
        var ab = card.querySelector("[data-acc]");
        if (ab) {
          ab.setAttribute("aria-expanded", "false");
          if (ap) ap.hidden = true;
        }
      }
    });

    var cur = t_(), Lc = live(state.tier), tokc = tokens(state.tier);
    var canSub = hasSub(state.tier);
    otBtn.parentNode.style.display = (!canSub || !Lc) ? "none" : "";
    if (canSub && Lc) {
      otLabel.textContent = state.mode === "sub"
        ? C.otPrefix
        : C.subPrefixFmt.replace("{pct}", Lc.savePct || 0);
      otPrice.textContent = money(state.mode === "sub" ? Lc.ot : Lc.sub);
      otBtn.classList.toggle("is-on", state.mode === "onetime");
    }

    trustG.textContent = fmt(cur.trustGuarantee || "", tokc);
    trustS.textContent = fmt((state.mode === "sub" ? cur.trustShipSub : cur.trustShipOt) || cur.trustShip || "", tokc);
    trustC.textContent = state.mode === "sub" ? fmt(cur.trustCancel || "Cancel Anytime", tokc) : "No Subscription";

    var why = blockReason(state.tier, state.mode);
    var blocked = !!why;
    cta.disabled = blocked && why !== "error";
    cta.textContent = why === "error" ? C.retryText : C.ctaText;
    cta.style.opacity = (blocked && why !== "error") ? ".45" : "";
    cta.style.cursor = (blocked && why !== "error") ? "not-allowed" : "pointer";
    cta.setAttribute("aria-busy", why === "loading" ? "true" : "false");

    if (why === "loading") {
      disc.textContent = "Loading current pricing…";
    } else if (why === "error") {
      disc.textContent = "We couldn't load current pricing. Tap Retry — no price is shown until it's confirmed with the store.";
    } else if (why) {
      disc.textContent = why;
    } else if (state.mode === "sub") {
      disc.textContent = (cur.discSub ? fmt(cur.discSub, tokc)
        : (money(Lc.sub) + " charged today, then " + money(Lc.sub) + " " + (cur.cycle || "") + " until you cancel.")) +
        " Pause, skip, change the date or cancel anytime from your account — no penalties, no hoops.";
    } else {
      disc.textContent = cur.discOt ? fmt(cur.discOt, tokc) : "One-time purchase. No subscription and no recurring charge.";
    }
  }

  cards.forEach(function (card) {
    var pick = function () {
      var key = card.getAttribute("data-tier");
      if (key === state.tier) return;
      state.tier = key; state.mode = "sub"; render(); fire("LP_TierSelect", true);
    };
    card.addEventListener("click", function (e) {
      if (e.target.closest("[data-acc]") || e.target.closest(".drbb__accpanel")) return;
      pick();
    });
    card.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") { e.preventDefault(); pick(); }
      if (/^Arrow/.test(e.key)) {
        e.preventDefault();
        var i = cards.indexOf(card);
        var n = cards[(i + (e.key === "ArrowUp" || e.key === "ArrowLeft" ? cards.length - 1 : 1)) % cards.length];
        if (n) { n.focus(); n.click(); }
      }
    });
  });

  otBtn.addEventListener("click", function () {
    state.mode = state.mode === "sub" ? "onetime" : "sub";
    render(); fire("LP_TierSelect", true);
  });

  root.querySelectorAll("[data-acc]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      var p = document.getElementById(btn.getAttribute("aria-controls"));
      if (p) p.hidden = open;
    });
  });

  var CART_MUTATION =
    "mutation C($input: CartInput!){ cartCreate(input:$input){" +
    " cart { checkoutUrl discountCodes { code applicable }" +
    " lines(first:20) { nodes { merchandise { ... on ProductVariant { id } }" +
    " cost { totalAmount { amount currencyCode } } } }" +
    " } userErrors { field message } } }";

  function permalink() {
    var t = t_();
    var url = C.shop + "/cart/" + vid(t.variant) + ":1";
    var p = new URLSearchParams();
    if (state.mode === "sub" && planConfigured(state.tier)) p.set("selling_plan", pid(t.sellingPlan));
    var a = attribution();
    Object.keys(a).forEach(function (k) { if (a[k]) p.set(k, a[k]); });
    var qs = p.toString();
    return qs ? url + "?" + qs : url;
  }

  function buildCartInput() {
    var t = t_();
    var lines = [{ merchandiseId: "gid://shopify/ProductVariant/" + vid(t.variant), quantity: 1 }];
    if (state.mode === "sub") lines[0].sellingPlanId = "gid://shopify/SellingPlan/" + pid(t.sellingPlan);
    var input = { lines: lines, attributes: attrPairs(), buyerIdentity: { countryCode: C.api.country } };
    var gift = giftFor();
    if (gift) {
      (gift.lines || []).forEach(function (g) {
        lines.push({ merchandiseId: "gid://shopify/ProductVariant/" + vid(g.variant), quantity: 1 });
      });
      if (gift.code) input.discountCodes = [gift.code];
    }
    return input;
  }

  function apiCheckout() {
    var L = live(state.tier);
    if (!L) return Promise.reject(new Error("PRICES_NOT_READY"));
    var expected = state.mode === "sub" ? L.sub : L.ot;
    return fetch(C.api.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": C.api.token },
      body: JSON.stringify({ query: CART_MUTATION, variables: { input: buildCartInput() } })
    }).then(function (x) { return x.json(); }).then(function (r) {
      var result = r && r.data && r.data.cartCreate;
      var c = result && result.cart;
      if (!c || !c.checkoutUrl || (result.userErrors && result.userErrors.length)) {
        throw new Error("Cart could not be created");
      }
      var rows = c.lines && c.lines.nodes || [];
      var mask = rows.filter(function (row) {
        return row.merchandise && row.merchandise.id === "gid://shopify/ProductVariant/" + vid(t_().variant);
      })[0];
      if (!mask || mask.cost.totalAmount.currencyCode !== C.currency ||
          Math.abs(Number(mask.cost.totalAmount.amount) - expected) > .011) {
        /* The store's price moved between page load and click: re-read, re-render, ask to confirm. */
        return fetchPrices().then(function () { render(); throw new Error("PRICE_CHANGED"); },
                                  function () { throw new Error("PRICE_CHANGED"); });
      }
      var gift = giftFor();
      if (gift) {
        var okay = (gift.lines || []).every(function (item) {
          return rows.some(function (row) {
            return row.merchandise &&
              row.merchandise.id === "gid://shopify/ProductVariant/" + vid(item.variant) &&
              row.cost.totalAmount.currencyCode === C.currency &&
              Math.abs(Number(row.cost.totalAmount.amount)) < .011;
          });
        });
        if (!okay) throw new Error("A promised gift was unavailable or not free");
        if (gift.code && !(c.discountCodes || []).some(function (d) {
          return d.code.toLowerCase() === gift.code.toLowerCase() && d.applicable;
        })) throw new Error("Gift discount was not applied");
      }
      fire("InitiateCheckout", false);
      window.location.href = c.checkoutUrl;
    });
  }

  function showError(msg) {
    var error = root.querySelector("[data-cart-error]");
    if (!error) {
      error = document.createElement("p");
      error.setAttribute("role", "alert");
      error.setAttribute("data-cart-error", "");
      error.style.cssText = "color:#8a3f54;font-size:14px;margin:10px 0";
      cta.parentNode.appendChild(error);
    }
    error.textContent = msg;
    error.hidden = !msg;
  }

  cta.addEventListener("click", function () {
    if (cta.disabled) return;
    showError("");
    if (!P.ready) {            /* Retry state: re-read prices, never fall back to a stored number */
      cta.disabled = true;
      fetchPrices().then(function () { render(); }, function () { render(); });
      return;
    }
    cta.disabled = true;
    apiCheckout().catch(function (err) {
      cta.disabled = false;
      var m = String(err && err.message || err);
      if (m === "PRICE_CHANGED") {
        showError("Pricing was just updated by the store — please review the price above and click again.");
      } else {
        showError("We couldn't confirm your cart and free gifts. Please try again or contact support.");
      }
      if (window.console && console.error) console.error("DRBB cart:", err);
    });
  });

  attribution();
  render();                                            /* shell + skeleton, no numbers */
  var ready = fetchPrices().then(function () { render(); return P; }, function (err) {
    if (window.console && console.error) console.error("DRBB prices:", err);
    /* one silent retry after a beat, then the CTA becomes Retry */
    return new Promise(function (res) { setTimeout(res, 1500); }).then(fetchPrices).then(
      function () { render(); return P; },
      function (e2) { render(); return P; });
  });

  window.DRBB = {
    version: "2.2.0", config: C, state: state, render: render, prices: P, live: live, ready: ready,
    refresh: function () { return fetchPrices().then(function () { render(); return P; }); },
    permalink: permalink, cartInput: buildCartInput, checkout: apiCheckout, root: root
  };
})();
